import { createFileRoute } from '@tanstack/react-router'

import { useAdminRedemption } from '@repo/common/queries/admin/redeem'

import { RedemptionDetail } from '@/components/Redeem/RedemptionDetail'
import { withTitle } from '@/utils/withTitle'

export const Route = createFileRoute('/_app/redeem/$id/$redemptionId')({
  component: RedemptionDetailPage,
  head: withTitle((params) => `Redemption ${params.redemptionId!.slice(0, 8)}`),
})

function RedemptionDetailPage() {
  const { id, redemptionId } = Route.useParams()
  const { data: redemption, isLoading } = useAdminRedemption(redemptionId!)

  return (
    <RedemptionDetail
      redemption={redemption}
      isLoading={isLoading}
      redeemableId={id!}
    />
  )
}
